/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import jobIcon from '../general/media/icons/briefcase.svg';
import graduationIcon from '../general/media/icons/graduation.svg';
import './style/lecturerAlumni.css';

/**
 * AlumniFront Component
 *
 * @param {Object} props - Component properties
 * @param {Object} props.item - The data item to be displayed on the front side of the card
 * @param {Function} props.onMoreInfo - Function to handle more info button click
 * @param {number} props.index - The index of the card in the list
 * @param {number} props.arrayLength - The total number of cards in the array
 * @param {number} props.position - The position of the card in the array
 *
 * @returns {JSX.Element} AlumniFront component
 */
const AlumniFront = ({ item, onMoreInfo, index, arrayLength, position }) => (
  <div className='card__side card__side--front'>
    {item && (
      <>
        <div className='card__upperBox'>
          {/* Display the current position and total number of items */}
          <p className='swipingStatus'>
            {position}{' '}
            <FormattedMessage id='tinbit.counter' defaultMessage='von' />{' '}
            {arrayLength}
          </p>
          <div className='card__personTop'>
            <div className='card__personTop--box' />
            {/* Display the alumnus' image */}
            <img
              className='card__personTop--image'
              src={item.image}
              alt={item.name}
              loading='lazy'
            />
          </div>
        </div>
        <div className='card__details'>
          {/* Display the alumnus' name */}
          <h2 className='card__person--name'>{item.name}</h2>
          <hr className='card__divider card__divider-person' />
          <div className='card__facts'>
            <div className='card__facts-item'>
              <span className='card__facts-text'>
                <img
                  src={graduationIcon}
                  alt='graduation-Icon'
                  className='card__facts-icon'
                />{' '}
                <FormattedMessage
                  id='tinbit.graduation'
                  defaultMessage='Abschlussjahr'
                />
              </span>
              {/* Display the graduation year */}
              <h3 className='card__facts-value'>{item.graduationYear}</h3>
            </div>
            <div className='card__facts-item'>
              <span className='card__facts-text'>
                <img
                  src={jobIcon}
                  alt='job-Icon'
                  className='card__facts-icon'
                />{' '}
                <FormattedMessage
                  id='tinbit.currentJob'
                  defaultMessage='Aktueller Job'
                />
              </span>
              {/* Display the current job and company */}
              <h3 className='card__facts-valueJob'>{item.currentJob}</h3>
              <p className='card__facts-valueCompany'>@{item.currentCompany}</p>
            </div>
          </div>
          {/* Button to view more info (CV) */}
          <button
            className='card__button card__button--more-info'
            onClick={index === 0 ? onMoreInfo : null}
            style={{ pointerEvents: index === 0 ? 'auto' : 'none' }}
            type='button'
          >
            <FormattedMessage
              id='tinbit.toCV'
              defaultMessage='Zum Lebenslauf'
            />
          </button>
        </div>
      </>
    )}
  </div>
);

export default AlumniFront;
